// extracted by mini-css-extract-plugin
export default {"container":"EditManufacturer_container__mNjKr","progressContainer":"EditManufacturer_progressContainer__ZdGn3"};